import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import NFTMarketplace from "views/admin/TeamManagement";
import Profile from "views/admin/profile";
import DataTables from "views/admin/tables";
import RTLDefault from "views/rtl/default";
import Analytics from "views/admin/Player Analytics";
// import TeamAnalytics from "views/admin/TeamAnalytics"
import TeamAnalytics from "views/admin/TeamAnalytics";
import SelectedTeamAnalytics from "views/admin/TeamAnalytics/SelectedTeamAnalytics";
// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import {
  MdHome,
  // MdOutlineShoppingCart,
  // RiTeamFill,
  MdBarChart,
  MdPerson,
  MdLock,
  MdSettings,
} from "react-icons/md";

import {
  RiTeamFill
} from "react-icons/ri";
import TeamManagement from "views/admin/TeamManagement";
import { IoMdWallet } from "react-icons/io";
import CoachManagement from "views/admin/CoachManagement";
import PlayerManagement from "views/admin/PlayerManagement";
import PlayerAnalytics from "views/admin/Player Analytics/playerAnalytics";

const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  {
    name: "Teams",
    layout: "/admin",
    path: "team-management",
    icon: <RiTeamFill className="h-6 w-6" />,
    component: <TeamManagement />,
    secondary: true,
  },
  {
    name: "Coaches",
    layout: "/admin",
    path: "Coaches",
    icon: <MdPerson className="h-6 w-6" />,
    component: <CoachManagement />,
  },
  {
    name: "Players",
    layout: "/admin",
    path: "Players",
    icon: <MdPerson className="h-6 w-6" />,
    component: <PlayerManagement />,
  },
  {
    name: "Player Analytics",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "player-analytics",
    // component: <DataTables />,
    component: <PlayerAnalytics />
  },
  {
    name: "Team Analytics",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "team-analytics",
    // component: <DataTables />,
    component: <TeamAnalytics />
  },
  {
    name: "Individual Player Analytics",
    layout: "/admin",
    path: "analytics/:playerId",
    component: <Analytics />,
    hidden: true, // This will hide it from the sidebar if you're using these routes to generate a menu
  },
  {
    name: "Individual Player Analytics",
    layout: "/admin",
    path: "selected-team-analytics/:teamId",
    component: <SelectedTeamAnalytics />,
    hidden: true, // This will hide it from the sidebar if you're using these routes to generate a menu
  },
  // {
  //   name: "Subscription",
  //   layout: "/admin",
  //   path: "subscription",
  //   icon: <IoMdWallet className="h-6 w-6" />,
  //   // component: <Profile />,
  // },
  // {
  //   name: "Profile Settings",
  //   layout: "/admin",
  //   path: "profile-settings",
  //   icon: <MdSettings className="h-6 w-6" />,
  //   // component: <Profile />,
  // },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
    hidden: true,
  },
  // {
  //   name: "RTL Admin",
  //   layout: "/rtl",
  //   path: "rtl",
  //   icon: <MdHome className="h-6 w-6" />,
  //   component: <RTLDefault />,
  // },
];
export default routes;
